import { create } from "zustand";

import type { AuthStore } from "@/types/auth";

export const useAuthStore = create<AuthStore>()((set) => ({
	accessToken: null,
	setAccessToken: (token) => set({ accessToken: token }),
	logout: () => set({ accessToken: null }),
}));

export const getAccessToken = () => useAuthStore.getState().accessToken;
export const setAccessToken = (token: string | null) =>
	useAuthStore.getState().setAccessToken(token);
export const logout = () => useAuthStore.getState().logout();
